/* eslint-disable no-param-reassign */
import Axios, { AxiosError, AxiosRequestConfig } from 'axios';

import { BASE_API_URL, ENDPOINTS, USER_METADATA } from '../../constants';
import Storage from '../../utils/storage/storage';
import { navigateTo } from '../../utils/navigateHelper';

// Check if this is the first load for the current user session
function isFirstLoadForUser(): boolean {
  const hasLoadedBefore = sessionStorage.getItem('app_has_loaded');
  return !hasLoadedBefore;
}

// Mark that the app has loaded for this user session
function markAppAsLoaded(): void {
  sessionStorage.setItem('app_has_loaded', 'true');
}

function authRequestInterceptor(config: AxiosRequestConfig) {
  // Only apply default token when caller did not explicitly set Authorization
  if (!config.headers.Authorization) {
    const token = Storage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  config.headers.Accept = 'application/json';
  return config;
}


// function authErrorHandler(error) {
//     const err = error as AxiosError
//   if (
//     error instanceof axios.isAxiosError &&
//     error.response &&
//     error.response.status === 401 &&
//     error.response.data?.code === 'token_not_valid'
//   ) {
//     Storage.removeTokens();
//     window.location.href = '/login';
//   }
//   return Promise.reject(error);
// }

const axios = Axios.create({
  baseURL: BASE_API_URL
});

function authErrorHandler(error) {
  const status = error.response?.status;
  const url = error.config?.url;
  const isError = status >= 400 && status < 600 && status !== 403 && status !== 404 && status !== 502;
  const isForbidden = status === 403;
  const isUnderMaintainance = status === 502;
  const isUserMetadataError = url?.includes(USER_METADATA);

  // Skip 403 errors on first load for this user session
  if ((isForbidden || isUserMetadataError) && !isFirstLoadForUser()) {
    navigateTo(ENDPOINTS.noaccess);
  }

  // Mark that the app has loaded for this user session after any error
  markAppAsLoaded();

  if (isUnderMaintainance) {
    navigateTo(ENDPOINTS.maintainance);
  }
  if (isError) {
    navigateTo(ENDPOINTS.errorPage);
  }
  return Promise.resolve(null);
}

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(null, authErrorHandler);

export default axios;
